import { useCurrentBrandQuery } from '@/hooks/queries/use-current-brand-query';
import { useDemoInvitationQuery } from '@/hooks/queries/use-demo-invitation-query';

/** The invitation for the brand on screen; the server decides where it shows. */
export function useDemoInvitation() {
  const { data: brand } = useCurrentBrandQuery();
  const { data: invitation } = useDemoInvitationQuery(brand?.id);
  return { brandId: brand?.id, invitation };
}
